import { render, staticRenderFns } from "./ServiceBanquetStep4.vue?vue&type=template&id=ae6cec8a&scoped=true"
import script from "./ServiceBanquetStep4.vue?vue&type=script&lang=js"
export * from "./ServiceBanquetStep4.vue?vue&type=script&lang=js"
import style0 from "./ServiceBanquetStep4.vue?vue&type=style&index=0&id=ae6cec8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6cec8a",
  null
  
)

export default component.exports